<template>
  <div class="dog-wrap">
    <div class="dog-body">
      <img class="img-dog" src="./images/dog.png" />
      <img class="img-dogdizuo" src="./images/dog-dizuo.png" />
      <div class="dog-text">
        <span class="title">您好，欢迎来到 Geek Hand ~</span>
        <span class="txt">我是你的数字员工，请称呼我{{curRobot?.name}}就好啦～</span>
        <span class="txt">你还没有安排任务哦，快来安排任务吧，我们会极力地帮助你完成！</span>
        <span class="txt">可以先来看看我们都有哪些技能吧！<i @click="goandlook">去看看<el-icon><Right /></el-icon></i></span>
      </div>
    </div>
    <MathineList @change="changeHandle" />
  </div>

  <div class="nobuy-tip-wrap" v-if="notbuyTipFlag">
    <div class="nobuy-tip">
      <img src="./images/nobuy.svg" />
      <span>您尚未开通服务，请联系极羽客服了解更多信息~</span>
      <el-button type="primary" style="align-self: flex-end;" @click="notbuyTipFlag = false">知道了</el-button>
    </div>
  </div>
</template>

<script setup>
  import { Right } from '@element-plus/icons-vue'
  import { onMounted, ref } from 'vue';
  import * as Request from '@/assets/request';

  import MathineList from '@/pages/dispatch/components/mathinelist'

  const emits = defineEmits(['click'])

  const curRobot = ref(null);
  const changeHandle = target => {
    curRobot.value = target;
  }

  // 判断用户是否购买，无购买提示
  const notbuyTipFlag = ref(false)
  // 判断用户的机器是否创建了任务，无任务提示
  const hasTaskTipFlag = ref(false)
  // 机器列表
  const mathineList = ref([])
  const getMachines = async () => {
    const result = await Request.post({
      url: '/22001/facade/dispatch/machines'
    });
    if(result?.code != 200) return;

    if(result?.data?.length > 0) {
      mathineList.value = result.data;

      result.data.map(item => {
        if(item.createdTask) {
          hasTaskTipFlag.value = true
        }
      })
    }
  }
  onMounted(() => {
    getMachines()
  })

  const goandlook = () => {
    // [接口数据]用户购买判断
    if(mathineList.value?.length == 0) {
      notbuyTipFlag.value = true
      return
    }
    
    emits('click', hasTaskTipFlag.value)
  }
</script>

<style scoped lang="less">
@import "./index.less";
</style>
